import React from 'react';
import { Typography, Skeleton } from '@mui/material';
import { useGetGuidanceByClassOfRiskQuery } from '@/features/classesOfRisk/classesOfRiskApi';
import { FolioDrawer } from '@/components/Drawers/FolioDrawer';

export const ProductGuidanceDrawer = ({ open, handleClose, classOfRisk, label, brokerGroupIds = [] }) => {
	const { data: guidance, isLoading, error } = useGetGuidanceByClassOfRiskQuery(
		{ classOfRisk, brokerGroupIds },
		{ skip: !open || !classOfRisk || !brokerGroupIds.length }
	);

	return (
		<FolioDrawer open={open} onClose={handleClose} title={label || classOfRisk}>
			{isLoading ? (
				<Skeleton variant="rectangular" height={400} />
			) : error ? (
				<Typography color="error">Error loading guidance content. Please try again later.</Typography>
			) : guidance ? (
				<div dangerouslySetInnerHTML={{ __html: guidance.description }} />
			) : null}
		</FolioDrawer>
	);
};
